var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.23 145.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #6f1d46;\n        stroke-width: 7px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.62,
    cy: 49.09,
    r: 22.35,
    transform: "translate(22.95 121.31) rotate(-89.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.25,113.56c-1.91-16-14.43-28.64-30.37-30.73-6.45,7.15-15.63,11.25-25.26,11.27-9.63-.02-18.81-4.12-25.26-11.27-15.94,2.09-28.46,14.74-30.37,30.73"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.62,
    cy: 72.62,
    r: 69.12,
    transform: "translate(-14.74 126.61) rotate(-76.72)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.f6021f3a680a05b9b2f4f06f7f69d591.svg";
export { ForwardRef as ReactComponent };